import { render, staticRenderFns } from "./WorkspaceCreateModal.vue?vue&type=template&id=4e348b76&scoped=true"
import script from "./WorkspaceCreateModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreateModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCreateModal.vue?vue&type=style&index=0&id=4e348b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e348b76",
  null
  
)

export default component.exports